import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  class: "content",
  style: {}
}
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "line2" }
const _hoisted_7 = { class: "line2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "t6_table_b t6_table_b2" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "t6_table_b t6_table_b2" }
const _hoisted_12 = { class: "t6_table_b" }
const _hoisted_13 = { key: 2 }

import { getDetailByProjid, getOnethingDetail } from '@/config/request';
import { ElMessage } from 'element-plus';
import { reactive, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let keywords = ref('')
let captcha = ref('')
const dialog = reactive({
    dialogVisible: false,
    title: '',
    detail1:{} as any,

    detail2:{} as any,
})
const query = async() => {
    if(!keywords.value){
        return false
    }else if(!captcha.value){
        ElMessage.warning('请输入查询密码')
        return false
    }
    dialog.title = ''
    dialog.detail1 = {}
    dialog.detail2 = {}
    let res = await getData1()
    if(!res){
        getData2()
    }
    dialog.dialogVisible = true
    captcha.value = ''
}
//  查询单事项业务
const getData1 = async() => {
    let res = {} as any
    let param2 = {
        projid: keywords.value, 
        
    }
    const result = await getDetailByProjid(param2) as any
    res = result.result?.result?.preApasinfo
    let title = ''
    if(res){
        title = res?.servicename
        dialog.detail1 = res
        dialog.title = `业务【${title}】详情`
        console.log('dialog.detail1',dialog.detail1);
    }
    return title
    
}
//  查询一件事业务
const getData2 = async() => {
    let res = {} as any
    let param1 = {
        onethingUnid: keywords.value,
        
    }
    const result = await getOnethingDetail(param1) as any
    console.log('result', result);
    res = result.result?.result?.preOnethingApasinfo
    let serviceList = result.result?.result?.preApasinfos

    if(res){
        let title = res?.name
        dialog.detail2 = res
        dialog.title = `业务【${title}】详情`
        console.log('dialog.detail2',dialog.detail2);
        dialog.detail2.serviceList = serviceList
    }
    
}
const reset = () => {
    keywords.value = ''
    captcha.value = ''
}


return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[30] || (_cache[30] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "container mar_b" }, [
            _createElementVNode("div", { class: "t6_breadCream" }, [
              _createElementVNode("span", null, "首页"),
              _createElementVNode("i", null, ">"),
              _createTextVNode(),
              _createElementVNode("span", null, " 进度查询")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "line1" }, "查询办事情况(您可凭申办者和申办流水号查询办事状态和办事结果)", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", null, "申办流水号:", -1)),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      maxlength: "40",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(keywords) ? (keywords).value = $event : keywords = $event))
                    }, null, 512), [
                      [_vModelText, _unref(keywords)]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", null, "查询密码:", -1)),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      maxlength: "10",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(captcha) ? (captcha).value = $event : captcha = $event))
                    }, null, 512), [
                      [_vModelText, _unref(captcha)]
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "button" }, [
                  _createElementVNode("div", {
                    class: "bt1",
                    onClick: query
                  }, "查 询"),
                  _createElementVNode("div", {
                    class: "bt1 reset",
                    onClick: reset
                  }, "重 填")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_dialog, {
            modelValue: dialog.dialogVisible,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog.dialogVisible) = $event)),
            title: dialog.title,
            width: "800px",
            class: "dialog_content"
          }, {
            default: _withCtx(() => [
              (dialog.detail1.applyCardnumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("table", _hoisted_9, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[7] || (_cache[7] = _createElementVNode("th", null, "申请人姓名", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail1.applyname), 1),
                          _cache[8] || (_cache[8] = _createElementVNode("th", null, "手机号码", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail1.telphone), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[9] || (_cache[9] = _createElementVNode("th", null, "证件类型", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail1.applyCardtype), 1),
                          _cache[10] || (_cache[10] = _createElementVNode("th", null, "证件号码", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail1.applyCardnumber), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[11] || (_cache[11] = _createElementVNode("th", null, "部门名称", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail1.deptname), 1),
                          _cache[12] || (_cache[12] = _createElementVNode("th", null, "办理节点", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail1.handlestate), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[13] || (_cache[13] = _createElementVNode("th", null, "办件类型", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail1.infotype), 1),
                          _cache[14] || (_cache[14] = _createElementVNode("th", null, "查询密码", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail1.projpwd), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[15] || (_cache[15] = _createElementVNode("th", null, "申请时间", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail1.createTime), 1),
                          _cache[16] || (_cache[16] = _createElementVNode("th", null, "申报类型", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail1.applyType), 1)
                        ])
                      ])
                    ])
                  ]))
                : (dialog.detail2.applicantCardNum)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("table", _hoisted_11, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[17] || (_cache[17] = _createElementVNode("th", null, "申请人姓名", -1)),
                            _createElementVNode("td", null, _toDisplayString(dialog.detail2.applicantName), 1),
                            _cache[18] || (_cache[18] = _createElementVNode("th", null, "手机号码", -1)),
                            _createElementVNode("td", null, _toDisplayString(dialog.detail2.applicantPhone), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[19] || (_cache[19] = _createElementVNode("th", null, "证件类型", -1)),
                            _createElementVNode("td", null, _toDisplayString(dialog.detail2.applicantCardType), 1),
                            _cache[20] || (_cache[20] = _createElementVNode("th", null, "证件号码", -1)),
                            _createElementVNode("td", null, _toDisplayString(dialog.detail2.applicantCardNum), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[21] || (_cache[21] = _createElementVNode("th", null, "区域名称", -1)),
                            _createElementVNode("td", null, _toDisplayString(dialog.detail2.areaName), 1),
                            _cache[22] || (_cache[22] = _createElementVNode("th", null, "办理节点", -1)),
                            _createElementVNode("td", null, _toDisplayString(dialog.detail2.handleState), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[23] || (_cache[23] = _createElementVNode("th", null, "申请时间", -1)),
                            _createElementVNode("td", null, _toDisplayString(dialog.detail2.createTime), 1),
                            _cache[24] || (_cache[24] = _createElementVNode("th", null, "查询密码", -1)),
                            _createElementVNode("td", null, _toDisplayString(dialog.detail2.createTime), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[25] || (_cache[25] = _createElementVNode("th", null, "业务类型", -1)),
                            _cache[26] || (_cache[26] = _createElementVNode("td", null, "一件事业务", -1)),
                            _cache[27] || (_cache[27] = _createElementVNode("th", null, "申报类型", -1)),
                            _createElementVNode("td", null, _toDisplayString(dialog.detail2.applyType), 1)
                          ])
                        ])
                      ]),
                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "title" }, "包含的单事项业务:", -1)),
                      _createElementVNode("table", _hoisted_12, [
                        _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { width: "500" }, "办件名称"),
                            _createElementVNode("th", { width: "100" }, "办理状态"),
                            _createElementVNode("th", null, "办件部门")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialog.detail2.serviceList, (item) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.projid
                            }, [
                              _createElementVNode("td", null, _toDisplayString(item.servicename), 1),
                              _createElementVNode("td", null, _toDisplayString(item.handlestate), 1),
                              _createElementVNode("td", null, _toDisplayString(item.deptname), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_el_empty, { description: "未查询到数据" })
                    ]))
            ]),
            _: 1
          }, 8, ["modelValue", "title"])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})